import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import BuSpecificHeader from "../../components/Header/BuSpecificHeader";
import "./style.scss";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import {setCustomerDetails} from "../../actions/customer";
import IdInputField from "../IDInputField/IdInputField";
import {setShowKeyboard, setUrlLinkSource} from "../../actions/global";
import KeyboardComponent from "../../components/Keyboard/Keyboard";

import config from "../../../config";

const GuestLandingPage = () => {
  const {t} = useTranslation();
  let customerSlotDetails = getCustomerSlotDetails();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {customerDetails, showKeyboard} = useSelector((state) => {
    return {
      customerDetails: state.customerReducer?.customerDetails || null,
      showKeyboard: state.globalReducer?.showKeyboard,
    };
  });

  const [buLinkSource, setBuLinkSource] = useState(null);
  const [isTurneroEnabledBu, setIsTurneroEnabledBu] = useState(false);

  useEffect(() => {
    dispatch(setShowKeyboard(false));
    const customerDetails = getCustomerSlotDetails() || null;
    dispatch(setCustomerDetails(customerDetails || null));
  }, []);

  useEffect(() => {
    if (customerDetails) {
      const type = customerDetails?.origin || null;
      dispatch(setUrlLinkSource(type));
      setBuLinkSource(type);
      if (config.turnero_enabled_bu_list.includes(customerDetails?.bu)) {
        setIsTurneroEnabledBu(true);
      } else {
        setIsTurneroEnabledBu(false);
      }
    }
  }, [customerDetails]);

  const proceedServiceSelectionPage = () => {
    const data = getCustomerSlotDetails();
    if (config.turnero_enabled_bu_list?.includes(data?.bu)) {
      navigate("/customer/selectTurneroStoreAndType");
    }
  };

  return (
    <div className="guestLandingPage-container">
      {buLinkSource?.toLowerCase() === "web" ? <BuSpecificHeader /> : null}
      <div className="w-full bg-white shadow-sm py-6 px-6">
        <p className="text-[#343E49] text-sm font-semibold">En tienda</p>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center px-6 pt-6 mt-6">
        <div className="w-full max-w-[406px] flex flex-col items-start">
          <h1 className="text-[#343E49] text-[40px] font-bold italic leading-[100%] mb-4 font-[Lato,sans-serif]">
            {t("welcome")}
          </h1>
          <p className="text-left text-[#343E49] text-base mb-6 w-full">
            {config.turnero_enabled_bu_list.includes(customerSlotDetails?.bu)
              ? t("turneroenabled.bookingDisabled.entryText")
              : customerSlotDetails?.bu === "Car Center"
              ? t("nonturnero.selectionPage.entryText.Carcenter")
              : t("nonturnero.selectionPage.entryText")}
          </p>
          {isTurneroEnabledBu ? (
            <button
              onClick={proceedServiceSelectionPage}
              className="w-full max-w-[406px] bg-[#343E49] text-white py-[18px] px-8 rounded-[40px] text-base font-semibold hover:bg-opacity-90 transition-colors"
            >
              {t("book.shift")}
            </button>
          ) : (
            <IdInputField isWelcomePage={true} />
          )}
        </div>
      </div>
      {showKeyboard && (
        <KeyboardComponent
          country={customerSlotDetails?.country}
        ></KeyboardComponent>
      )}
    </div>
  );
};
export default GuestLandingPage;
